import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection, isDevMode
} from '@angular/core';
import {provideRouter} from '@angular/router';
import {routes} from './app.routes';
import {provideClientHydration, withHttpTransferCacheOptions} from '@angular/platform-browser';
import {IonicStorageModule} from '@ionic/storage-angular';
import {Drivers} from '@ionic/storage';
import CordovaSQLiteDriver from 'localforage-cordovasqlitedriver';
import {provideHttpClient, withFetch} from '@angular/common/http';
import {StorageService} from './shared/storage.service';
import {provideAngularSvgIcon} from 'angular-svg-icon';
import {provideIonicAngular} from '@ionic/angular/standalone';
import { provideServiceWorker } from '@angular/service-worker';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideHttpClient(withFetch()),
    provideRouter(routes),
    provideClientHydration(withHttpTransferCacheOptions({})),
    provideAngularSvgIcon(),
    importProvidersFrom(IonicStorageModule.forRoot({
      name: '__opgoeiegrond',
      driverOrder: [CordovaSQLiteDriver._driver, Drivers.IndexedDB, Drivers.LocalStorage]
    })),
    provideIonicAngular({}),
    provideAppInitializer(async () => {
      const initFunction = ((storageService: StorageService) => {
        return storageService.init();
      });
      await initFunction(inject(StorageService));
    }), provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
          }),
  ],
};
